import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./UploadOverlay.scss";

export default function UploadOverlay({ visible, progress = 0, status = "Uploading image", inline = false }) {
  const card = useRef(null);
  useEffect(() => {
    if (!visible || inline || typeof document === "undefined") return;
    const previous = document.activeElement;
    card.current?.focus();
    return () => { if (previous?.isConnected) previous.focus(); };
  }, [visible, inline]);
  if (!visible) return null;
  const pct = Number.isFinite(progress) ? Math.max(0, Math.min(100, Math.round(progress))) : 0;
  const content = (
    <div className={`ant-upload${inline ? " ant-upload--inline" : ""}`}
      onClick={(event) => event.stopPropagation()} onMouseDown={(event) => event.stopPropagation()}>
      <div className="ant-upload__card" aria-busy="true" ref={card} tabIndex={inline ? undefined : -1}
        role={inline ? undefined : "dialog"} aria-modal={inline ? undefined : true} aria-label="Uploading"
        onKeyDown={(event) => { if (!inline && event.key === "Tab") event.preventDefault(); }}>
        <span role="status">{status || "Uploading image"}…</span>
        <div className="ant-upload__progress">
          <progress aria-label="Upload progress" max="100" value={pct} />
          <span>{pct}%</span>
        </div>
      </div>
    </div>
  );
  return inline || typeof document === "undefined" ? content : createPortal(content, document.body);
}
